import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getSystemState } from "@/api/system.js";
export default {
  name: "State",
  data: function data() {
    return {
      timer: null,
      state: {},
      colors: [{
        color: "#5cb87a",
        percentage: 20
      }, {
        color: "#e6a23c",
        percentage: 40
      }, {
        color: "#f56c6c",
        percentage: 80
      }]
    };
  },
  created: function created() {
    var _this = this;
    this.reload();
    this.timer = setInterval(function () {
      _this.reload();
    }, 1000 * 10);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    reload: function reload() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getSystemState, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getSystemState();
            case 2:
              _yield$getSystemState = _context.sent;
              data = _yield$getSystemState.data;
              _this2.state = data.server;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};